import styled from '@emotion/styled'

import { BayName } from './BayName'


type BayItemOffProps = {
  name: string
  size?: 'lg' | 'md' | 'sm'
}

const StyledBayItemOff = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: ${({theme}) => theme.bay.background};
  padding: 10px 16px;
  
  &.sm {
    padding: 8px 12px;
  }
`

export default function BayItemOff({name, size}: BayItemOffProps) {
  return (
    <StyledBayItemOff data-testid="bay-off" className={size}>
      <BayName className={`off ${size}`}>{name}</BayName>
    </StyledBayItemOff>
  )
}
